import React from "react";
import DashboardContent from "../components/DashboardContent";

const Dashboard: React.FC = () => {
  return <DashboardContent />;
};

export default Dashboard;
